// extracted by mini-css-extract-plugin
module.exports = {"brandLogo":"style_brandLogo__moQlN"};